import React from 'react';
import { Icon } from '@components/atoms/icon';
import type { ModalProps } from '@components/moleculs/modal/types';
import { styled } from 'styled-components';

import { CloseIcon } from '../../icons';

import { Modal as MuiModal } from './styles';

const Molecule: React.FC<ModalProps> = ({ hasCloser, children, ...rest }) => (
    <MuiModal {...rest}>
        {hasCloser && (
            <Icon
                className='closer'
                $clickable={true}
                icon={<CloseIcon />}
                onClick={(event) => {
                    if (rest.onClose) {
                        rest.onClose(event, 'escapeKeyDown');
                    }
                }}
            />
        )}
        {children}
    </MuiModal>
);

export const Modal = styled(Molecule)({});
